import React from 'react'

const Item = ({ style, children }) => {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                ...style,
            }}
        >
            {children}
        </div>
    )
}

export default Item
